import React, { useEffect, useState } from "react";
import { Line } from 'react-chartjs-2';
import "../../styles.scss";

const Graph = ({ data: propData }) => {
  const [chartData, setChartData] = useState({});

  useEffect(() => { 
    const datasets = {}
    Object.keys(propData).forEach(data => {
      Object.keys(propData[data]).forEach(d => {
        if (datasets[d]) {
          datasets[d]['data'].push(propData[data][d] || 0)
        } else {
          datasets[d] = {
            label: d,
            data: [propData[data][d] || 0],
            borderColor: [`#${Math.floor(Math.random()*16777215).toString(16)}`],
            borderWidth: 2,
            fill: false
          }
        }
      })
    });

    setChartData({
      labels: Object.keys(propData),
      datasets: Object.keys(datasets).map(data => datasets[data])
    })
  }, [propData]);

  return (
    <div className="graph">
      <Line
        width={1200}
        height={300}
        data={chartData}
        options={{
          elements: {
            line: {
              tension: 0,
            }
          },
          responsive: true,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          legend: {
            display: true,
          },
        }}
      />
    </div>
  );
};

export default Graph;
